import { Checkbox, FormControlLabel, Link, Typography } from "@mui/material";
import { storeChildWindows } from "../../../../explorer/utils/UtilsFunctions";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { useFormClasses } from "./CreateOfferOrderForm.style";
import { LinkOrderAgreementStyled } from "./OrderAgreement.style";

type OrderAgreementProps = {
  value: boolean;
  onChange: (event: any, checked: any) => void;
  orderAgreementUrl: string;
  setEnable:any
  enable:boolean;
  
};

const OrderAgreement: React.FC<OrderAgreementProps> = (props) => {
    const { t } = useTranslation();
    const classesForm = useFormClasses();

    const handleClickUrl = (event: any) => {
        event.stopPropagation();
        event.preventDefault();
        var wind = window.open(props.orderAgreementUrl);
        storeChildWindows(wind);
        props.setEnable(true)
        return false;
    };

    return (
        <>
            <FormControlLabel
                control={
                    <Checkbox
                        color="primary"
                        name="ExpandAll"
                        value={props.value}
                        onChange={(event, checked) => {
                            props.onChange(event, checked);
                        }}
                        disabled={!props.enable}
                        sx={classesForm.checkbox}
                    />
                }
                label={
                    <Typography
                        component="span"
                        sx={classesForm.title}
                        id="orderAgreement"
                    >
                        {t("orderoffer.acceptance")}
                        <LinkOrderAgreementStyled
                            href="#"
                            onClick={handleClickUrl}
                            
                        >
                            {t("orderoffer.service_cond_agreement")}
                        </LinkOrderAgreementStyled>
                    </Typography>
                }
                labelPlacement="end"
                //style={{ marginLeft: "0", alignItems: "start" }}
            />
        </>
    );
};
export default OrderAgreement;
